import script from "./UserCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCenter.vue?vue&type=script&setup=true&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=52b52dea&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b52dea"]])

export default __exports__